import React, { useRef, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_ACTIVATE_URL, API_BASE_URL } from '../constants';
import '../components/Dashboard/UserDashboard.css';
import { Tooltip } from './Tooltip';
import './Register.css';

const SetAgencyUserPassword: React.FC = () => {
    const { actionGuid } = useParams();
    const navigate = useNavigate();
    const isNavigated = useRef(false);
    const [isActivated, setIsActivated] = useState(false);
    //const [isActivated, setIsActivated] = useState(true); //  TEST --> false default
    const [error, setError] = useState<string>('');

    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');


    useEffect(() => {
        const activateUser = async (retries = 3) => {
            if (!actionGuid) return;

            try {
                await axios.post(
                    API_ACTIVATE_URL,
                    { ActionId: actionGuid.toUpperCase() },
                    { headers: { 'Content-Type': 'application/json' } }
                ).then((response) => {
                    setEmail(response.data.email);
                });

                if (!isNavigated.current) {
                    isNavigated.current = true;
                    setIsActivated(true);
                }
            } catch (error) {
                if (retries > 0) {
                    setTimeout(() => activateUser(retries - 1), 1000); // Retry after 1 second
                } else {
                    if (!isNavigated.current) {
                        isNavigated.current = true;
                        setIsActivated(false);
                        setError('Die Aktivierung des Accounts ist fehlgeschlagen. Bitte versuchen Sie es erneut.');
                    }
                }
            }
        };

        activateUser();
    }, [actionGuid]);

    const handlePasswordChange = async (e: React.FormEvent) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('Die Passwörter stimmen nicht überein. Bitte überprüfen Sie Ihre Eingabe.');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }
        try {
            await axios.post(
                `${API_BASE_URL}/set-password/secure-endpoint/${actionGuid}`,
                {
                    Email: email,
                    Password: password,
                },
                { headers: { 'Content-Type': 'application/json' } }
            );

            navigate('/login', {
                state: {
                    message: 'Ihr Passwort wurde erfolgreich festgelegt. Bitte melden Sie sich an.',
                    type: 'success'
                }
            });
            window.scroll(0, 0);
        } catch (error) {
            setError(`Das Passwort konnte nicht festgelegt werden. Versuchen Sie es erneut. (Fehlercode: ${error})`);
        }
    }


    return (
        <>
            <div className="empty-container">
            </div>
            {isActivated ? (
                <>
                    <div className="auth-container">
                        <div className="p-3 border-bottom-grey">
                            <h1 className="login-title">Passwort festlegen</h1>
                        </div>
                        <div className="p-3">
                            <p className="login-subtitle">
                                Bitte legen Sie ein Passwort für Ihren Account fest.
                            </p>
                            {error && <div className="alert alert-danger">{error}</div>}
                            <form onSubmit={handlePasswordChange}>
                                <div className="form-group">
                                    <label htmlFor='setPassword'>Neues Passwort</label>
                                    <Tooltip text="Das Passwort muss mindestens 8 Zeichen lang sein">
                                        <input
                                            id='setPasswordd'
                                            className="form-control"
                                            type="password"
                                            placeholder="Neues Passwort"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                    </Tooltip>
                                </div>
                                <div className="form-group">
                                    <label htmlFor='setConfirmPassword'>Neues Passwort bestätigen</label>
                                    <input
                                        id='setConfirmPassword'
                                        className="form-control"
                                        type="password"
                                        placeholder="Bestätigen Sie Ihr neues Passwort"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                        readOnly={password.length < 8 && confirmPassword === ''}
                                    />
                                </div>
                                <div className="form-group bt">
                                    <button className="login-button" type="submit" disabled={(password && confirmPassword) === ''} >Passwort bestätigen</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </>
            ) : (
                <div className='loader'></div>
            )}
        </>
    )
}

export default SetAgencyUserPassword;